<div class="row page-header">
    <div class="col-12">
        <h1>Small Tool and Consumable Material Transfer <small>Record the transfer of tools and consumable materials</small></h1>
    </div>
</div>
<div class="container-sm" style="max-width: 600px; padding: 10px" [hidden]="isInitialLoading">
    <form [hidden]="saved">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col" [ngClass]="isCollapsed ? 'collapsed-div' : 'full-div'">
                        <ngx-scanner-qrcode
                            #action="scanner"
                            (event)="onScan($event)"
                            [config]="config"
                            (error)="onError($event)"
                        ></ngx-scanner-qrcode>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="tool"
                                [displayMemberPath]="'display'"
                                [itemsSource]="toolOptions"
                                [selectedValuePath]="'value'"
                                [(selectedValue)]="tool"
                                name="tool"
                                [isRequired]="false"
                                [isEditable]="false"
                                (selectedIndexChanged)="toolChanged()"
                            >
                            </wj-auto-complete>
                            <label for="tool">Consumable/Tool</label>
                        </div>
                    </div>
                </div>
                <div class="row" [hidden]="isToolInstance || !tool">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="source"
                                [displayMemberPath]="'display'"
                                [itemsSource]="sourceOptions"
                                [selectedValuePath]="'value'"
                                [(selectedValue)]="source"
                                name="source"
                                [isRequired]="false"
                                [isEditable]="false"
                                (selectedIndexChanged)="getSourceQuantities()"
                            >
                            </wj-auto-complete>
                            <label for="source">Consumable/Tool <b>SOURCE</b></label>
                        </div>
                    </div>
                </div>
                <div class="row" [hidden]="!tool || (!isToolInstance && !source)">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="destination"
                                [displayMemberPath]="'display'"
                                [itemsSource]="destinationOptions"
                                [selectedValuePath]="'value'"
                                [(selectedValue)]="destination"
                                name="destination"
                                [isRequired]="false"
                                [isEditable]="false"
                                (selectedIndexChanged)="validationMessage = ''"
                            >
                            </wj-auto-complete>
                            <label for="vehicle">Consumable/Tool <b>DESTINATION</b></label>
                        </div>
                    </div>
                </div>
                <div class="row" [hidden]="isToolInstance || !tool">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-input-number
                                id="quantity"
                                [isRequired]="false"
                                [format]="'n1'"
                                [step]="1"
                                [(value)]="quantity"
                                name="quantity"
                                (valueChanged)="validationMessage = ''"
                            ></wj-input-number>
                            <label for="quantity" *ngIf="quantityAvailable === 0">Quantity</label>
                            <label for="quantity" *ngIf="quantityAvailable > 0"
                                >Quantity - <b>{{ quantityAvailable }} available</b></label
                            >
                        </div>
                    </div>
                </div>
                <div class="row" [hidden]="!tool">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="requestedByHrRef"
                                [displayMemberPath]="'display'"
                                [itemsSource]="userList"
                                [selectedValuePath]="'value'"
                                [(ngModel)]="requestedByHrRef"
                                name="requestedByHrRef"
                                [isRequired]="false"
                            >
                            </wj-auto-complete>
                            <label for="requestedByHrRef">Requested By</label>
                        </div>
                    </div>
                </div>

                <!--<div class="row" [hidden]="!tool || !destination">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete id="job" [displayMemberPath]="'display'" [itemsSource]="jobOptions" [selectedValuePath]="'value'" (selectedIndexChanged)="validationMessage = ''"
                                              [(selectedValue)]="job" name="job" [isRequired]="false">
                            </wj-auto-complete>
                            <label for="job">Job</label>
                        </div>
                    </div>
                </div>-->
                <div class="row" *ngIf="validationMessage">
                    <div class="col">
                        <p class="validation">
                            There may be an issue with your entries. Please see the issue below and check that you have the correct entries.
                            You can correct your inputs or save the record anyway.
                        </p>
                        <p class="text-danger" style="font-weight: bold">{{ validationMessage }}</p>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 30px">
                    <div class="col-md-6 col-sm-12" style="margin-bottom: 10px">
                        <button mat-raised-button (click)="reset()">Reset</button>
                    </div>
                    <div class="col-md-6 col-sm-12" style="margin-bottom: 10px">
                        <button
                            mat-raised-button
                            [color]="validationMessage ? 'warn' : 'primary'"
                            [disabled]="!tool || !destination"
                            (click)="save()"
                        >
                            <span *ngIf="!isSaving && validationMessage">Save Anyway</span>
                            <span *ngIf="isSaving"><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                            <span *ngIf="!isSaving && !validationMessage">Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div [hidden]="!saved">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 saved">
                <div style="text-transform: uppercase">The entry has been saved</div>
                <table class="results-table">
                    <tr>
                        <td>Tool/Material:</td>
                        <td>{{ tool }}</td>
                    </tr>
                    <tr [hidden]="!source">
                        <td>Source:</td>
                        <td>{{ source }}</td>
                    </tr>
                    <tr>
                        <td>Destination:</td>
                        <td>{{ destination }}</td>
                    </tr>
                    <tr [hidden]="!quantity">
                        <td>Quantity:</td>
                        <td>{{ quantity }}</td>
                    </tr>
                    <!--<tr [hidden]="!job">
                        <td>Job:</td>
                        <td>{{job}}</td>
                    </tr>-->
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 saved">
                <button mat-raised-button color="primary" (click)="reset()">Transfer Another</button>
            </div>
        </div>
    </div>
</div>
